import React from "react";
import MyCard from "../../../tools/MyCard";
import { SolidButton } from "../../../global/SolidButton";
import { CalendarMinus2, Check, Copy, FilePlusCorner, Pen, Pencil, Trash } from "lucide-react";
import MyTabs from "../../../tools/MyTabs";
import SearchBar from "../../../tools/SearchBar";
import { Tab } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function () {
  const navigate = useNavigate();
  return (
    <>
      <div className="w-full flex flex-col px-4">
        <div>
          <MyTabs
            position="left"
            className=" space-x-2 items-center justify-between w-full"
            children={
              <>
                {/* search */}
                <SearchBar />
                <SolidButton 
                onClick={()=>{
                  navigate('/apps/:id/settings/callback/add');
                }}
                className="ml-auto">
                  <FilePlusCorner className="w-4 h-4" />
                  <span>Add Callback</span>
                </SolidButton>
              </>
            }
            tabs={[
              {
                label: "All Callbacks",
                content: <TableView filter="all" />,
              },
              {
                label: "Active",
                content: <TableView filter="active" />,
              },
              {
                label: "Inactive",
                content: <TableView filter="inactive" />,
              },
            ]}
          />
        </div>
      </div>
    </>
  );
}
export const TableView = ({ filter }) => {
  return (
    <div className="space-y-2">
      <MyCard>
        <table className="min-w-full border-collapse  rounded-t-lg overflow-hidden">
          <thead>
            <tr className="bg-slate-100 dark:bg-slate-800/60 border-t border-slate-300 dark:border-slate-700">
              <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 ps-4 py-3 ">
                Source
              </th>
              <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                Platform
              </th>
              <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                Method
              </th>
              <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                Status
              </th>
              <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                Created At
              </th>
              <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-white dark:bg-slate-800/60 hover:bg-slate-300/10 hover:dark:bg-slate-900/10 border-t border-slate-300 dark:border-slate-700">
              <td className="text-start  text-[11px] font-semibold font-sans text-slate-700 dark:text-slate-400 ps-4 py-4 ">
                Mobile Games
              </td>
              <td className="text-start text-[10px] font-semibold font-sans text-slate-700 dark:text-slate-400 py-4">
                iOS
              </td>
              <td className="text-start text-[10px] text-slate-600 dark:text-slate-400 py-4">
                <div className="bg-green-300/30 dark:bg-green-300/20 w-fit flex items-center justify-center px-2  py-[2px] rounded-2xl">
                  POST
                </div>
              </td>
              <td className="text-start text-xs  py-4">
                <div className="w-5 h-5 relative">
                  <input
                    class="w-5 h-5 appearance-none cursor-pointer dark:border-gray-700 border border-gray-300 checked:border-transparent rounded-md 
                  checked:bg-brand-500 disabled:opacity-60  checked:bg-blue-500"
                    type="checkbox"
                    checked="true"
                  />
                  <Check className="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 pointer-events-none text-white w-4 h-4" />
                </div>
              </td>
              <td className="flex text-xs text-slate-600 dark:text-slate-400 py-4">
                <div className="flex items-center justify-center space-x-1">
                  <CalendarMinus2 strokeWidth={1.25} className="w-4 h-4 mt-0.5 mr-2 text-slate-600 dark:text-slate-400" />
                  <span>

                  2024-06-01 12:34 PM
                  </span>
                  


                </div>
              </td>
              <td className="text-start text-xs text-slate-600 dark:text-slate-400 py-4">
                <div className="flex items-center justify-start space-x-2">
                  <Copy
                    strokeWidth={1.1}
                    className="w-7 h-7 p-[6px] text-slate-600 dark:text-slate-300 rounded-lg hover:bg-gray-400/20"
                  />
                  <Pencil
                    strokeWidth={1.1}
                    className="w-7 h-7 p-[6px] text-slate-600 dark:text-slate-300 rounded-lg hover:bg-gray-400/20"
                  />
                  <Trash
                    strokeWidth={1.1}
                    className="w-7 h-7 p-[6px] text-red-600 dark:text-red-300 rounded-lg hover:bg-gray-400/20"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </MyCard>
    </div>
  );
};
